import { render, staticRenderFns } from "./ParcelaSeleccionada.vue?vue&type=template&id=0e6ba25c&scoped=true&"
import script from "./ParcelaSeleccionada.vue?vue&type=script&lang=js&"
export * from "./ParcelaSeleccionada.vue?vue&type=script&lang=js&"
import style0 from "./ParcelaSeleccionada.vue?vue&type=style&index=0&id=0e6ba25c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6ba25c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCarousel,VCarouselItem,VCol,VContainer,VLayout,VRow,VSnackbar,VTextField})
